import ContratoInterceptor from '../ContratoInterceptor'

const api = new ContratoInterceptor()

export default {
  addOperadoras(contradoId: String, grupoRemuneracaoId: String, operadoras: String[]) {
    return api.post(`/contratos/${contradoId}/grupos-remuneracao/${grupoRemuneracaoId}/operadoras`, operadoras)
  },

  getOperadoras() {
    return api.get(`/operadoras`)
  },

  getOperadorasByContratoId(contratoId: String) {
    return api.get(`/contratos/${contratoId}/operadoras`)
  },

  getOperadorasByFilters(contratoId, localExecucaoId) {
    return api.get(`/operadoras/${contratoId}/${localExecucaoId}`)
  },

  getOperadorasByLocalExecucaoId(contratoId: String, localExecucaoId: String) {
    return api.get(`contratos/${contratoId}/locais-execucao/${localExecucaoId}/operadoras`)
  },


  removeOperadoras(contradoId: String, grupoRemuneracaoId: String, operadoraId: String) {
    return api.delete(`/contratos/${contradoId}/grupos-remuneracao/${grupoRemuneracaoId}/operadoras/${operadoraId}`)
  },
}
